import { addRestaurantTablesWaiterCall, removeRestaurantTablesWaiterCall, updateRestaurantTable } from '../../redux/action/restaurant'
import { setTableCartSplits } from '../../redux/action/tableCart'
import { fetchRestaurantAreasThunk } from '../../redux/thunk/restaurant/table'
import { logger } from '../../logger/logger'

export const processRestaurantMessageThunk = (message) => (dispatch) => {
	switch (message?.type) {
		case 'restaurant.TABLE_UPDATED_EVENT':
			handleUpdateTable(message.data, dispatch)
			break
		case 'restaurant.WAITER_IS_CALLED_EVENT':
			logger.info(`Get waiter is called event data = ${JSON.stringify(message.data)}`)
			dispatch(addRestaurantTablesWaiterCall(message.data))
			break
		case 'restaurant.WAITER_CALL_CANCELLED_EVENT':
			logger.info(`Get waiter call cancelled event data = ${JSON.stringify(message.data)}`)
			dispatch(removeRestaurantTablesWaiterCall(message.data))
			break
		default:
			logger.error('Unknown restaurant message type: ', JSON.stringify(message))
			break
	}
}

export const handleUpdateTable = (data, dispatch) => {
	if (window.location.pathname === '/restaurant') {
		dispatch(updateRestaurantTable(data))
		dispatch(setTableCartSplits(data.splits))
		dispatch(fetchRestaurantAreasThunk())
	}
}
